module.exports = __webpack_public_path__ + "static/media/sygnet.49c54739.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/sygnet.svg
// module id = 986
// module chunks = 0